<template>
  <div class="page">
    <m-face-home v-if="!imgUrl"/>
    <m-face-verify ref="mFace" :imgUrl="imgUrl" v-else=""/>
    <div class="m-footer x-flex-center">
      <van-uploader :after-read="afterRead" :multiple="true" :max-count="1" accept="image/*" capture="user" :before-read="beforeRead">
        <van-button v-if="!imgUrl" block class="x-btn-log m-btn">拍照识别</van-button>
        <van-button v-if="imgUrl&&isUpKey==2" block class="x-btn-log m-btn-next" @click.stop="goTo()">下一步</van-button>
        <van-button v-if="imgUrl&&isUpKey==1" block class="x-btn-log m-btn-ag">重新识别</van-button>
        <div></div>
      </van-uploader>
    </div>
  </div>
</template>

<script>
  import mFaceHome from "./components/m-face-home"
  import mFaceVerify from "./components/m-face-verify"
  import { mapGetters } from 'vuex'
  export default {
    components: { mFaceHome,mFaceVerify },
    computed: {
      ...mapGetters({
        CONFIG_ITEM: 'enroll/configItem'
      })
    },
    data () {
      return {
        imgUrl:'',
        file:{},
        isUpKey:''
      }
    },
    created () {

    },
    methods: {
//      onOversize(file){
//        this.utils.toastNone('文件大小不能超过30MB')
//      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只能选择一张图片上传！')
          return false
        }
        if(e.size>20971520){
          this.utils.toastError('文件大小不能超过20MB！')
          return false
        }
        return true
      },
      afterRead(e){
        this.imgUrl = e.content
        this.file = e
        if(e.file&&e.file.size>2000000){
          this.compressFile(e)
        } else {
//          let msg = new FormData()
//          msg.append('imgBase64', e.content);
//          msg.append('enrollId', this.CONFIG_ITEM.id);
          this.http.postRequest({
//            headers: {'Content-Type': 'multipart/form-data'},
            url: 'app/faceAuth/authFace',
            msg: {
              imgBase64:e.content,
              enrollId:this.CONFIG_ITEM.id,
            },
            special:true,
          },true).then((res)=>{
            if(res.code==500){
              this.isUpKey = 1
              this.$refs.mFace.isUpKey = 1
              this.$refs.mFace.message = res.msg
            }
            if(res.code==200){
              this.isUpKey = 2
              this.$refs.mFace.isUpKey = 2
              this.$refs.mFace.message = res.msg
            }
          },true)
        }
      },
      compressFile(file){
        let canvas = document.createElement("canvas")
        let context = canvas.getContext("2d");
        let img = new Image();
        img.src = file.content;
        img.onload = ()=>{
          var newWidth = img.width * 0.7; //压缩后图片的宽度
          var newHeight = img.height * 0.7; //压缩后图片的高度
          // 指定canvas画布大小，该大小为最后生成图片的大小
          canvas.width = newWidth;
          canvas.height = newHeight;
          context.drawImage(img, 0, 0, newWidth, newHeight);
          file.content = canvas.toDataURL(file.file.type, 0.5);
//          console.log('压缩后的文件',file.content)
//          let msg = new FormData()
//          msg.append('imgBase64', file.content);
//          msg.append('enrollId', this.CONFIG_ITEM.id);
          this.http.postRequest({
//            headers: {'Content-Type': 'multipart/form-data'},
            url: 'app/faceAuth/authFace',
            msg: {
              imgBase64:file.content,
              enrollId:this.CONFIG_ITEM.id,
            },
            special:true,
          },true).then((res)=>{
            if(res.code==500){
              this.isUpKey = 1
              this.$refs.mFace.isUpKey = 1
              this.$refs.mFace.message = res.msg
            }
            if(res.code==200){
              this.isUpKey = 2
              this.$refs.mFace.isUpKey = 2
              this.$refs.mFace.message = res.msg
            }
          },true)

        }
      },
      goTo(){
        if(this.CONFIG_ITEM&&this.CONFIG_ITEM.userRegisterStatus==1){
          this.$router.push({
            path:'/myEnroll',
          })
        } else {
          this.$router.push({
            path:'/examInfo',
            query:this.$route.query
          })
        }
        
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page{
    padding: 0 32px 20px 32px ;
    .m-footer{
      width: 100%;
      margin-top: 92px;
      .m-btn{
        width: 132px;
        /*margin-top: 92px;*/
      }
      .m-btn-next{
        width: 210px;
        z-index: 100;
      }
      .m-btn-ag{
        width: 210px;
      }
    }
  }
</style>

